/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-14 18:30:19
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-14 18:30:38
 * @FilePath: /unifyxp-v2-store-portal/src/components/Icon/index.ts
 */
export { default as DeleteIcon } from './Delete';
